import * as qs from "query-string";
import { setCompanyId } from "apis/user";

export default function callbackUrl<
  T extends { url: string; companyid: string; token: string; invalid: string }
>(params: T, token: string) {
  let finnalUrl = params.url;
  // 解密
  const decode = (str: string) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  };

  if (params.url.indexOf("http") === -1) {
    finnalUrl = decode(params.url);
  }
  params.token = token;
  params.invalid = "1";
  // 处理token失效 企业id为0 的情况
  if (params.url.indexOf("companyid") !== -1) {
    let companyid = params.url.split("?companyid=")[1];
    companyid =
      companyid.indexOf("&") !== -1 ? companyid.split("&")[0] : companyid;
    setCompanyId({ companyId: companyid });
  }
  // 处理地址一样  一直死循环问题
  if (window.location.href.split("?")[0] !== params.url.split("?")[0]) {
    window.location.href = qs.stringifyUrl({
      url: finnalUrl,
      query: filterParams(params)
    });
  } else {
    window.location.href = finnalUrl;
  }
}

export function filterParams<T extends { url: string; companyid: string; token: string; invalid: string }>(params: T) {
  var fliterParams: any = {};
  Object.entries(params).forEach((param) => {
    if (param[1] && param[1] != undefined && param[1] != "") {
      fliterParams[param[0]] = param[1]
    }
  })
  return fliterParams;
}
